// mapbox
import mapboxgl from 'mapbox-gl';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

// services
import { useService } from '@/vue3/api/services';

export const useGeoRecordDelete = () => {
    // hooks
    const {
        removeGeoRecord,
        removeSelectedGeoRecord,
        removeGeoRecordExtrusion,
    } = useGeoRecord();

    // services
    const { deleteGeoRecord, deleteMultipleGeoRecord } = useService();

    // methods
    const deleteGeoRecordLayer = async (map: mapboxgl.Map, geoRecord: any) => {
        await deleteGeoRecord(geoRecord.id);
        removeSelectedGeoRecord(map, geoRecord);
        removeGeoRecordExtrusion(map, geoRecord);
        removeGeoRecord(map, geoRecord);
    };

    const deleteMultipleGeoRecordLayer = async (
        map: mapboxgl.Map,
        geoRecords: any,
        geoRecordIds: any,
    ) => {
        await deleteMultipleGeoRecord(geoRecordIds);

        for (const geoRecord of geoRecords) {
            removeSelectedGeoRecord(map, geoRecord);
            removeGeoRecordExtrusion(map, geoRecord);
            removeGeoRecord(map, geoRecord);
        }
    };

    return {
        deleteGeoRecordLayer,
        deleteMultipleGeoRecordLayer,
    };
};
